export const DELETE_ROLE = 'delete_role';
export const UPDATE_ROLE = 'update_role';
